/**
 * Gets a message to share the app with others.
 *
 * @param inviteCode The invite code to include in the message.
 * @returns A message with the invite code and a link to download the app.
 */
export const getShareMessage = (inviteCode: string) =>
  `Hey, checkout this new app I'm using to improve my wellbeing. It's currently 'invite only' and I can get you access if you use this code: "${inviteCode}". Download here: https://miindset.com/app`;
